import React from 'react'
import { Tooltip, Position, Icon, Intent } from '@blueprintjs/core'

const BPIcon = ({ icon, iconSize, color, intent, tooltip, onClick, className }) => {
  return (
    <Tooltip popoverClassName='blueprintTooltip' content={tooltip} position={Position.BOTTOM} intent={Intent.NONE} disabled={tooltip == null || tooltip === ''}>
      {/* <Icon icon={icon} iconSize={iconSize || Icon.SIZE_STANDARD} color={color || Colors.GRAY1} onClick={onClick} /> */}
      <Icon icon={icon} className={`cursor-pointer ${className}`} iconSize={iconSize || Icon.SIZE_STANDARD} color={color} intent={intent || Intent.NONE} onClick={onClick} />
    </Tooltip>
  )
}

export default BPIcon
